// Widget Scripts
import videoFeature from './widgets/videoFeature.js';
import cardWidget from './widgets/cardWidget.js';
import autoEvent from './widgets/autoEvent.js';
import seoWidget from './widgets/seoWidget.js';
import infographic from './widgets/infographic.js';

export function initWidgetsHomepage() {
  $(globalThis).load(function () {
    videoFeature();
  });
  cardWidget({
    widgetName: 'cardWidget',
    widgetOpts: cardWidgetOpts,
    wrapContainerClass: 'cardWidget-container-wrapper',
    showMoreButton: true,
    allLink: false,
  });
  cardWidget({
    widgetName: 'hotButtons',
    widgetOpts: hotButtonsOpts,
    wrapContainerClass: 'hotButtons-container-wrapper',
    showMoreButton: false,
    allLink: true,
  });
  autoEvent();
  seoWidget({
    widgetNameVariable: 'seoWidget',
    widgetOptsVariable: seoWidgetOpts,
    useImageBackground: true,
    useDividers: true,
  });
  infographic('infographic', infographicOpts, 4, 'Rooted in Community');
}
